import { useCadastrarEditarProdutoContext } from "../../../../contexts/CadastrarEditarProdutoContext";
import { ConsultarIndustrializadoContainer } from "../../../../containers/ConsultarIndustrializadoContainer";
import { PrecificacaoIndustrializadoContainer } from "../../../../containers/PrecificacaoIndustrializadoContainer";
import { ControleEstoqueContainer } from "../../../../containers/ControleEstoqueContainer";
import { ConfiguracaoKDSContainer } from "../../../../containers/ConfiguracaoKDSContainer";

interface CadastrarIndustrializadoContainerProps {}

export const CadastrarIndustrializadoContainer = ({}: CadastrarIndustrializadoContainerProps) => {
    const { step } = useCadastrarEditarProdutoContext();

    return (
        <>
            {step == 0 && (
                <ConsultarIndustrializadoContainer />
            )}
            {step == 1 && (
                <PrecificacaoIndustrializadoContainer />
            )}
            {step == 2 && (
                <ControleEstoqueContainer />
            )}
            {step == 3 && (
                <ConfiguracaoKDSContainer />
            )}
        </>
    );
}
